import { render, staticRenderFns } from "./CompaniesCRM.vue?vue&type=template&id=4a0d47c9&scoped=true"
import script from "./CompaniesCRM.vue?vue&type=script&lang=js"
export * from "./CompaniesCRM.vue?vue&type=script&lang=js"
import style0 from "./companies-crm.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./CompaniesCRM.vue?vue&type=style&index=1&id=4a0d47c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0d47c9",
  null
  
)

export default component.exports